// extracted by mini-css-extract-plugin
module.exports = {"flex":"Capitulo__flex__3B2xM","cuadroEnlace":"Capitulo__cuadroEnlace__XHcHa","imgContainer":"Capitulo__imgContainer__3sPKB","textCapitulos":"Capitulo__textCapitulos__NSwJ7"};